import styled from "styled-components";

export const ShowMessageWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
position: fixed;
top: 0;
left: 0;
bottom: 0;
width: 100%;
background-color: rgba(0,0,0,0.4);
padding-top: 50px;
.close{
    position: absolute;
    top: 10px;
    right: 12px;
    cursor: pointer;
    span{
        display: inline-block;
        background-color: #fff;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        padding: 2px 16px;
        border-radius: 12px;
    }
}

.buttons{
   margin-top: 20px;
   text-align: end;
 button{
 display: inline-block;
 width: auto;
 margin-right: 20px;
 border-radius: 4px;
 background-color: #00BAF2;
 color: #fff;
 transition: all .3s;
 &:hover{
   background-color: #00a5d7;
    
 }
}
}

.logo{
    position: absolute;
    top: 38px;
    left: 20px;
}

.errorMsg{
    text-align: center;
    font-weight: 700;
    margin-top: 20px;
}
.modelBox{
    flex: 0 1 500px;
    width: 480px;
    background-color: #002970;
    padding: 30px 0;
    border-radius: 12px;
    position: absolute;
    top: 40px;
    margin-bottom: 40px;
    overflow-x: hidden;
    overflow-y: auto;
    .model-body{
        line-height: 25px;
        font-size: 13px;
        .amount{
            text-align: center;
            font-weight: 700;
            font-size: Roboto;
            
            margin-bottom: 32px;
            .amountValue{
                font-size: 30px;
            }
            .amountWord{
                font-weight: normal;
            }
        }
        .transtionDetail{
            margin: 23px;
            padding: 10px;
            background-color: #F8F8F8;
            .detail{
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
                position: relative;
                .detail-title{
                    font-weight: 600;
                }
                .detail-desc{
                    font-family: Poppins;
                    .tooltip{
                        visibility: hidden;
                        width: 86px;
                        background-color: black;
                        color: #fff;
                        text-align: center;
                        border-radius: 6px;
                        padding: 2px 0;
                        position: absolute;
                        z-index: 1;
                        bottom: -100%;
                        right: -36px;
                        &::after {
                            content: "";
                            position: absolute;
                            bottom: 100%;
                            left: 50%;
                            margin-left: -5px;
                            border-width: 5px;
                            border-style: solid;
                            border-color:  transparent transparent  black transparent;
                        }
                    }
                    img{
                        margin-left: 4px;
                        cursor: pointer;
                       &.active + .tooltip{
                        visibility: visible;
                        
                       }
                    }
                    &.success{
                        color: #0AA904;
                        img{
                            vertical-align: top;
                             margin: 7px 2px 0 0;
                        }
                    }
                }
            }
        }
        
    }
    .MinistatementList{
        margin: 0 23px;
        &>div{
           max-height: 150px;
           overflow: auto;
           &::-webkit-scrollbar {
            width: 10px;
        }

/* Track */
&::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
&::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
&::-webkit-scrollbar-thumb:hover {
  background: #555;
}
        }
        h3{
            color: #fff;
        }
        table{
            width: 100%;
            th{
                text-align: start;
                color: #fff;
            }

            
            tbody{
                tr:nth-child(odd){
                    background-color: #f9f9f9;
                }
                tr:nth-child(even){
                    background-color: #fff;
                }
            }
            td{
                padding: 8px;
            }
           
            td.red{
                color: red;
            }
            td.green{
                color: #0AA904;
            }
        }
    }
    @media print {
      .no-print {
        display: none;
      }
      .logo{
    position: absolute;
    top: 0px;
    left: 30px;
}
.MinistatementList{
    width: auto;
}
.MinistatementList > div{
    height: 500px!important;
    &::-webkit-scrollbar {
            width: 0;
        }
}
    }
}
`;


export const UploadWrapper = styled.div`

.upload{
    margin-bottom: 10px;
    h4{
        font-size: 12px;
        margin-left: 8px;
        font-weight: 600;
    }
}
`;